"use client";

import { useEffect } from "react";
import { useScrollLock } from "@/components/motion/SmoothScrollProvider";

/**
 * Locks document body scroll and Lenis smooth scroll when `locked` is true.
 * Safe outside SmoothScrollProvider (setScrollLocked is a no-op default).
 */
export function useBodyScrollLock(locked: boolean) {
  const { setScrollLocked } = useScrollLock();

  useEffect(() => {
    if (!locked) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    setScrollLocked(true);

    return () => {
      document.body.style.overflow = previousOverflow;
      setScrollLocked(false);
    };
  }, [locked, setScrollLocked]);
}
